import { createLogic } from "redux-logic"

import { dispatchError } from "utilities/dispatch-error"
import { fetchJson } from "utilities/fetch-json"
import { LOAD_ROLES, LOADED_ROLES, LOADING_ROLES, LOADING_ROLES_ABORT, LOADING_ROLES_ABORTED } from "./action_types"

const fetchRoles = createLogic({
    // declarative built-in functionality wraps your code
    type: LOAD_ROLES, // only apply this logic to this type
    cancelType: LOADING_ROLES_ABORT, // cancel on this type
    latest: false, // only take latest

    // your code here, hook into one or more of these execution
    // phases: validate, transform, and/or process
    async process(_, dispatch, done) {
        dispatch({
            type: LOADING_ROLES,
        })

        try {
            dispatch({
                type: LOADED_ROLES,
                roles_per_service: await fetchJson("/api/roles_per_service"),
            })
        } catch (err) {
            dispatch({
                type: LOADING_ROLES_ABORTED,
            })

            dispatchError(dispatch, err)
        }

        done()
    },
})

export default [fetchRoles]
